export type ContainerAdvancedSearchClassification = 'found' | 'not_found' | 'invalid';

export interface ContainerAdvancedSearchMatch {
  containerNumber: string;
  currentStatus?: string;
  lastEventDate?: string;
  referenceOrder?: string;
  currentStatusClass?: string;
  currentStatusIcon?: string;
  /** Código del tipo de contenedor (solo en sección Containers) */
  containerTypeCode?: string;
}

export interface ContainerAdvancedSearchRow extends ContainerAdvancedSearchMatch {
  classification: ContainerAdvancedSearchClassification;
}

export interface ContainerAdvancedSearchSummary {
  total: number;
  found: number;
  notFound: number;
  invalid: number;
}

export type ContainerAdvancedSearchSection = 'containers' | 'serviceOrder' | 'administration';

export interface ContainerAdvancedSearchDrawerData {
  title?: string;
  resolveMatches: (containerRefs: string[]) => Promise<ContainerAdvancedSearchMatch[]>;
  initialState?: ContainerAdvancedSearchState;
  /** Si es 'containers', la tabla del drawer muestra solo Número contenedor, Clasificación y Tipo */
  section?: ContainerAdvancedSearchSection;
}

export interface ContainerAdvancedSearchState {
  searchInput: string;
  rows: ContainerAdvancedSearchRow[];
  summary: ContainerAdvancedSearchSummary;
  searched: boolean;
}
